import React from "react";
import { Link } from "react-router-dom";
const StickyTableHeader = () => {
  return (
    <>
      <div className="hidden sm:mb-8 sm:flex sm:justify-center">
        {/* <div className="relative rounded-full px-3 py-1 text-sm/6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
          Announcing our next round of funding.{" "}
          <Link to="/" className="font-semibold text-indigo-600">
            <span aria-hidden="true" className="absolute inset-0" />
            Read more <span aria-hidden="true">&rarr;</span>
          </Link>
        </div> */}
      </div>
      
    </>
  );
};

export default StickyTableHeader;
